import { Component } from '@angular/core'
import { NavParams, ViewController } from 'ionic-angular'

/**
 * Generated class for the FlexMenuComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'flex-menu',
  templateUrl: 'flex-menu.html'
})
export class FlexMenuComponent {

  text: string;

  selectedOption: { name?: string, handler?: any };
  options: Array<{ name?: string, handler?: number }> = []
  user: { name: string, avatar: string, email: string }

  constructor(public navParams: NavParams, private viewCtrl: ViewController) {
    this.selectedOption = {}
    if (navParams.get('options')) {
      this.options = navParams.get('options')
    }
    if (navParams.get('user')) {
      this.user = navParams.get('user')
    }
  }

  select(selectedItem) {
    this.selectedOption = selectedItem;
    if (selectedItem && selectedItem.handler) {
      selectedItem.handler()
    }
    this.viewCtrl.dismiss(this.selectedOption);
  }

}



// WEBPACK FOOTER //
// ./src/components/flex-menu/flex-menu.ts